<template>
    <div>
        订单中心
    </div>
</template>

<script>
</script>

<style>
</style>
